const selectUserData = (state) => state.userData

export const selectTrackingParams = (state) => selectUserData(state).trackingParams
export const selectRestoredLink = (state) => selectUserData(state).restoredLink

export const selectAllUserData = (state) => selectUserData(state).data

export const selectVehicleType = (state) => selectAllUserData(state).type
export const selectPolicyHolder = (state) => selectAllUserData(state).policyHolder
export const selectUser = (state) => selectAllUserData(state).user

export const selectBonusType = (state) => selectAllUserData(state).bonusType
